import { pick } from 'ramda';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { getCleanPath } from 'js/utils/url.util';
import { useAppSelector } from 'js/store/hooks';
import { useNavigate } from 'js/hooks/navigate/useNavigate';

export const useForwardRootPage = ({ page }) => {
    const navigateWithReplace = useNavigate({ replace: true });
    const { rootPage, isChangeLangInProgress } = useAppSelector(pick(['rootPage', 'isChangeLangInProgress']));
    const location = useLocation();

    useEffect(() => {
        if (!page || getCleanPath(location.pathname) !== '/' || isChangeLangInProgress) {
            return;
        }

        const { friendlyURL } = page;

        if (friendlyURL === '') {
            navigateWithReplace(rootPage);
        }
    }, [rootPage, navigateWithReplace, page, location.pathname, isChangeLangInProgress]);
};
